export default __webpack_public_path__ + "static/media/06.087db3b3.jpg";